import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  vc_screenWidth: number;
  @ViewChild('drawer', { static: false }) obj_drawer: MatSidenav;

  constructor(public oc_commonService: CommonService) {
  }

  ngOnInit(): void {
    this.vc_screenWidth = window.innerWidth;
    window.onresize = () => {
      // set screenWidth on screen size change
      this.vc_screenWidth = window.innerWidth;
    }

    setTimeout(() => {
      this.oc_commonService.sideBar = this.obj_drawer;

      this.oc_commonService.slideEmitter.subscribe((open: boolean = false) => {
        if (open) {
          this.obj_drawer.close();
        } else {
          if (this.obj_drawer.opened) {
            this.obj_drawer.close();
          } else {
            this.obj_drawer.open();
          }
        }
      });

      this.oc_commonService.slideEmitter.emit(true);

      if (this.oc_commonService.isSidebarOpened === null) {
        this.oc_commonService.isSidebarOpened = 'false';
      }

      const isSidebarOpened = this.oc_commonService.isSidebarOpened.replace(/['"]+/g, '');
      if (isSidebarOpened === 'true') {
        this.obj_drawer.open();
      }
    });
  }
}
